import { Focus } from '@tmsw/powerups.services.focus';
import { useTranslate } from '@tmsw/powerups.intl.legacy.hooks.use-translate';
import { Button } from '@tmsw/powerups.ui.buttons.button';
import { usePauseConditions } from '../../../../../hooks/usePauseConditions';

export type SkipToCarouselProps = {
  forceFocus?: boolean;
  [key: string]: any;
};

const defaultProps = {
  forceFocus: false,
};

function SkipToCarousel(props: SkipToCarouselProps) {
  const { forceFocus, ...rest } = { ...defaultProps, ...props };
  const externalPauseTriggered = usePauseConditions()();
  const translate = useTranslate();
  const skipText = translate('skipToCarousel', 'GAME_PLAY');
  const selector = '#GameCarousel-SliderContainer ol li button';
  const handleClick = (e: any) => {
    const el = document.querySelector(selector) as HTMLElement | SVGElement;

    if (!Focus.isFocusable(el)) {
      if (forceFocus) {
        // TODO: probably should flag that we're changing the tabIndex on the el,
        // and bind keyboard nav (tab, arrows) to cleanup in an effect hook
        Focus.makeFocusable(el, false);
      } else {
        console.error(
          `Unable to call el.focus(). el is not focusable. To force focus with tabIndex, pass forceFocus in props.`
        );
      }
    }

    el.focus();
  };

  return externalPauseTriggered ? null : (
    <Button
      onClick={handleClick}
      tabIndex={0}
      title={skipText}
      aria-label={skipText}
      css={{
        fontSize: `clamp(0.5rem, 0.25vw + 0.5rem, 0.66rem)`,
        color: `white`,
        left: '0',
        top: '20vw',
        position: 'absolute',
        clip: 'rect(0, 0, 0, 0)',
        whiteSpace: 'nowrap',
        '&:focus': {
          clip: 'revert',
          padding: '0.25rem',
          backgroundColor: 'rgba(133, 120, 120, 0.8)',
          backgroundBlendMode: 'screen',
          outline: 'none',
          fontWeight: '700',
        },
        '&:focus-visible': {
          border: `solid 1px #FFE052`,
          borderRadius: '2px',
          boxShadow: 'none',
        },
      }}
      {...rest}
    >
      {skipText.toLocaleUpperCase()}
    </Button>
  );
}

SkipToCarousel.defaultProps = defaultProps;

export default SkipToCarousel;
